import { Action, Dispatch } from 'redux'
import { closeStaffModalAction } from 'reducks/modal/actions'

const closeStaffModal = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(closeStaffModalAction())
  }
}

export default closeStaffModal
